<script>
import TheNavbar from './components/globals/TheNavbar'

export default {
  components: {
    TheNavbar
  },
  data() {
    return {
      navbarItems: [
        {
          id: 1,
          name: 'Dashboard',
          path: '/dashboard',
          icon: 'notes-medical'
        },
        {
          id: 2,
          name: 'Timeline',
          path: '/timeline',
          icon: 'calendar'
        }
      ]
    }
  }
}
</script>

<template>
  <div id="app">
    <TheNavbar :items="navbarItems" />
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<style lang="sass">
@import url("//use.typekit.net/wsg6aag.css")
$family-sans-serif: sophisto, sans-serif

@import "~bulma/sass/utilities/_all"

$fullhd-enabled: false
$widescreen-enabled: false
$navbar-height: 3.75rem
$navbar-breakpoint: $tablet
$navbar-box-shadow-size: 0
$navbar-bottom-box-shadow-size: 0

$primary: #004953
$primary-invert: findColorInvert($primary)
$secondary: #0D6F7A
$secondary-invert: findColorInvert($secondary)
$tertiary: #78909C
$tertiary-invert: findColorInvert($tertiary)
$accent: #D70300
$accent-invert: findColorInvert($accent)
$warning: #FF9800
$warning-invert: findColorInvert($warning)
$success: #7AC943
$success-invert: findColorInvert($success)

$addColors: ("primary": ($primary, $primary-invert), "secondary": ($secondary, $secondary-invert), "tertiary": ($tertiary, $tertiary-invert), "accent": ($accent, $accent-invert), "warning": ($warning, $warning-invert), "success": ($success, $success-invert))
$colors: map-merge($colors, $addColors)


@import "~bulma"
@import "~bulma-extensions/bulma-timeline/dist/css/bulma-timeline.min.css"
@import '~bulma-pricingtable'
@import "~buefy/src/scss/buefy"

body
  font-weight: 100
  color: $primary
  margin: 0
  padding: 0
  line-height: 1.5

strong
  font-weight: 400

.title, .content .title
  color: $primary
  font-weight: 400

.subtitle, .content .subtitle,
h2, .content h2,
h3, .content h3,
h4, .content h4
  color: $secondary
  font-weight: 100

.content h2
  font-size: 2.2rem
  &:not(:first-child)
    margin-top: 4rem

.content h3
  font-size: 1.8rem
  &:not(:first-child)
    margin-top: 3rem

.spacer
  display: block
  margin: 1rem 0
  background: none
  border: none

p
  font-size: 1.5rem
  a
    color: $accent
  img
    border-radius: 10px

.icon-info
  color: rgba(48,87,169,0.71)
  margin-left: 5px

.datetimepicker .is-active
  z-index: 500

.datetimepicker-dummy-wrapper
  border-radius: 5px
  height: 37px !important
  border-color: #dbdbdb !important

.datetimepicker-dummy-input
  min-width: 150px
  z-index: 1

.select::after
  z-index: 0 !important

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button
  -webkit-appearance: none
  margin: 0

.button
  font-weight: 400

.help
  font-size: 1rem

.icon-info
  color: #78909c
  opacity: 0.5
  margin-left: 5px
  &:hover
    opacity: 1

a:not(.button):hover, .navbar-item a:not(.button):hover, .navbar-item a:not(.button).router-link-active
  color: $accent !important

.label
  font-weight: 500

.is-shown-print
  display: none

@media print
  .is-hidden-print
    display: none !important
  .is-shown-print
    display: block !important

@media all and (display-mode: standalone)
  .is-hidden-standalone
    display: none !important
</style>
